import { FlagProvider } from '@flags/flag-provider';
import { ThemeProvider } from '@lib/theme/theme-provider';
import { SnackbarProvider } from 'notistack';
import * as React from 'react';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter } from 'react-router-dom';

import { SentryErrorBoundary } from './sentry-error-boundary';

// This file stores all the providers that are used in the application.
export const ProvidersContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <CookiesProvider>
      <FlagProvider>
        <ThemeProvider>
          <SentryErrorBoundary>
            <BrowserRouter>
              <SnackbarProvider maxSnack={3}>{children}</SnackbarProvider>
            </BrowserRouter>
          </SentryErrorBoundary>
        </ThemeProvider>
      </FlagProvider>
    </CookiesProvider>
  );
};
